import styled, { keyframes } from 'styled-components';
import { respondTo } from '../../../styles/_respondTo';

export const load = keyframes`
 from {
        left: -150px;
    }
    to   {
        left: 100%;
    }
`;

export const StyledLoader = styled.div`
  width: ${({ fullWidth, w = 'auto' }) => fullWidth ? '100%' : w};
  height: ${({ height }) => height || '22px'};
  box-shadow: 0 4px 10px 0 rgba(33, 33, 33, 0.15);
  border-radius: 4px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: -150px;
    top: 0;
    height: 100%;
    width: 150px;
    background: linear-gradient(to right, transparent 0%, #E8E8E8 50%, transparent 100%);
    animation: ${load} 1s cubic-bezier(0.4, 0.0, 0.2, 1) infinite;
  }
  
  ${respondTo.mobile`
    max-width: 100%;
    width: ${({ mobileW = 'auto' }) => mobileW};
  `}
`;
